package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2024_03_08_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes who had called upon the Malusian army to end the siege of Cark. When the army arrived, our heroes engaged a flanking attack from orc warchiefs, goblins, ettin, a hill giant, and The Daveed that fled from the earlier battle with The Daveeds. Unfortunately, the Daveed escaped by teleporting to another plane. Our heroes were able to defeat the other enemies. Gorem then suggests that the heroes head Southeast to rejoin the Malusian soldiers. As our heroes approach, the battle is subsiding in victory and the liberation of Cark. The heroes head back to Dunstone on the way to Zedj.")
    }
}
